import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import Reveal from "../components/Reveal";

/** The marina's own Clean Marina copy, carried over verbatim. The live page's
 *  three buttons are dead anchors (href="#0"); they are reproduced here as inert
 *  controls so assistive tech is never told they lead somewhere. */
const BLOCKS = [
  {
    id: "best-boater-practices",
    heading: "BEST BOATER PRACTICES",
    lead:
      "From using safe cleaning alternatives, to ensuring your trash makes it to a safe disposal area, here are the best practices to be a “Clean Boater”",
    bullets: [
      "Best practices for being a Clean Boater include using safe cleaning alternatives.",
      "Another important practice is ensuring that trash is disposed of in a safe and appropriate manner.",
      "Following the Clean Boater guidelines and taking the pledge can help keep waterways clean and protect valuable resources.",
    ],
    image: "/site-assets/clean-marina/clean-boater.png",
    alt: "Ohio Clean Marina programme boaters",
    cta: "Be a Clean Boater",
  },
  {
    id: "take-the-pledge",
    heading: "TAKE THE PLEDGE",
    lead:
      "Once you have taken the time to learn how to do your part, take the pledge to be part of the Ohio Clean Marina Team!",
    bullets: [
      "Ohio Clean Marina encourages marinas and boaters to keep waterways clean.",
      "Take the pledge and follow best practices to become part of the Ohio Clean Marina Team.",
      "Fill out the pledge form and submit it to the marina by email or in person.",
    ],
    image: "/site-assets/clean-marina/pledge.png",
    alt: "Ohio Clean Marina pledge",
    cta: "Take the First Step",
  },
  {
    id: "nominate",
    heading: "NOMINATE",
    lead:
      "As part of our Clean Marina Pledge, we will be spotlighting 1 employee and 1 dock holder monthly who exemplifies what it means to be a clean boater! To nominate yourself or others please email us or message us on Facebook  with dock holder’s name and the act that made them stand out. All winners will receive a free lunch at our snack shop as well as mentions on our social media platforms!",
    bullets: [
      "Clean Marina Pledge promotes environmental stewardship.",
      "Monthly spotlight on employee and dock holder who demonstrate clean boating practices.",
      "Winners receive free lunch and social media mentions.",
    ],
    image: "/site-assets/clean-marina/nominate.png",
    alt: "Clean Marina certification",
    cta: "Share Your Story",
  },
];

export default function CleanMarina() {
  return (
    <>
      <Seo
        title="Clean Marina | West Branch Marina"
        description="Protecting Our Waterways: Our Commitment to Cleanliness."
        path="/clean-marina"
      />

      <PageHero eyebrow="Clean Marina" title="Protecting Our Waterways: Our Commitment to Cleanliness" />

      {BLOCKS.map((b, i) => (
        <Section key={b.id} tone={i % 2 === 0 ? "white" : undefined}>
          <div
            data-testid={`clean-marina-${b.id}`}
            className={`grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-16 ${
              i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
            }`}
          >
            <Reveal>
              <h2 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-lake">
                {b.heading}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate-700">{b.lead}</p>
              <ul className="mt-6 space-y-3">
                {b.bullets.map((t) => (
                  <li key={t} className="flex gap-3 text-sm leading-relaxed text-slate-600">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-ember" aria-hidden="true" />
                    {t}
                  </li>
                ))}
              </ul>
              {/* TODO: destination pending from operator -- inert on purpose. */}
              <button
                type="button"
                disabled
                aria-disabled="true"
                data-testid={`clean-marina-cta-${b.id}`}
                className="mt-8 inline-flex cursor-not-allowed items-center gap-2 rounded-full border border-navy/15 bg-sand-card px-7 py-3.5 text-sm font-bold text-navy/50"
              >
                {b.cta}
              </button>
            </Reveal>
            <Reveal delay={90}>
              <img
                src={b.image}
                alt={b.alt}
                className="w-full rounded-3xl border border-sand-border object-cover"
                loading="lazy"
              />
            </Reveal>
          </div>
        </Section>
      ))}
    </>
  );
}
